module.exports = angular.module('msi.product.image', []).name;

angular.module(module.exports)
  .component('ogProductImg', {
    controller: require('./product-image.controller'),
    template: '<div ng-style="$ctrl.styleObj"></div>',
    bindings: {
      url: '@ogUrl'
    }
  });
